import { Store } from 'stores/type';
import FirebaseApp from './app';
import FirebaseNotifications from './notifications';
import FirebaseAuthWrapper from './auth';
import FirebaseDatabase from './database';

class FirebaseManager {
  private $store!: Store;
  private app!: FirebaseApp;
  public auth!: FirebaseAuthWrapper;
  public notifications!: FirebaseNotifications;
  public database: FirebaseDatabase | null = null;

  public async init(store: Store) {
    this.$store = store;

    this.app = new FirebaseApp();
    await this.app.init();

    this.auth = new FirebaseAuthWrapper();
    this.auth.init(this.firebase, this.$store, {
      onLogin: this.onLogin,
      onLogout: this.onLogout,
    });

    this.notifications = new FirebaseNotifications();
    this.notifications.init(this.firebase, this.$store, async (token: string) => {
      await this.initDatabase();
      if (!this.database) throw new Error('database not initialized');

      return this.database.handler.sendNotificationsToken(token);
    });
  }

  private onLogin = () => {
    this.initDatabase();
  }
  private onLogout = () => {
    if (!this.database) return;

    this.database.destroy();
    this.database = null;
  }
  public async initDatabase() {
    this.database = new FirebaseDatabase();
    await this.database.init(this.firebase, this.$store, this.reinitialize);
  }

  public reinitialize = () => this.app.reinitialize();

  get firebase() {
    return this.app.firebase;
  }
}

export default new FirebaseManager();
